import React from 'react';
import PropTypes from 'prop-types';

import styles from './preRegInvitesTabContent.scss';
import AvatarV2 from '../../../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import Rating from '../../../../../components/cards/PlayerCard/SharedComponents/Rating';
import { medalNames, utrTypeIds, utrTypes } from '../../../../../utils/eventConstants';
import Img from '../../../../../components/Img';

const PreRegInvitedPlayer = (props) => {
    const {
        player,
        gridLayout,
        isPickleballEvent,
        isCurrentMemberAdmin,
        utrTypeId,
        sportTypeId,
        onDeleteInvite,
        onTogglePlayerSelect,
    } = props;

    const utrTypeKey = Object.keys(utrTypeIds).find(key => utrTypeIds[key] === utrTypeId);
    const utrTypeString = utrTypes[utrTypeKey] || 'Unknown';

    const handleSelectClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onTogglePlayerSelect(player);
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onDeleteInvite(player.preRegistrationInviteId);
    };

    const medalTiersList = Object.keys(medalNames).map((key) => parseInt(key, 10));
    const gridTemplateColumns = gridLayout?.map(fr => `minmax(0, ${fr})`).join(' ');
    const columnClassName = 'd-flex aic mr4';

    return (
        <div key={`player-${player.playerId}-${player.preRegistrationInviteId}`}>
            <div className={`utr-card division-card-v4 d-flex desktop ${styles.preRegInvitePlayerCard}`} style={{ background: '#fff' }}>
                <div style={{ background: '#fff', width: '100%' }}>
                    <div className="d-grid w-100" style={{ gridTemplateColumns }}>
                        <div
                            className={`${columnClassName} checkbox-wrapper pointer`}
                            onClick={handleSelectClick}
                        >
                            <div className={`checkbox-check ${player.isSelected ? 'checked' : ''}`}>
                                <Img src="/img/icons/checkmark-icon.svg" />
                            </div>
                        </div>
                        <div className={columnClassName}>
                            <div className="no-gutters">
                                <div className="d-flex aic" onClick={() => { }}>
                                    <div className={`d-flex aic oh pr8`}>
                                        <AvatarV2 player={player} />
                                    </div>
                                    <div className="d-flex flex-col">
                                        <a href={`/profiles/${player.playerId}`}>{player.firstName} {player.lastName}</a>
                                        <div className={`${styles.playerLocation} d-flex`}>
                                            <span>{player.gender}</span>
                                            {player.location?.display && (<span className="ellipsis">• {player.location?.display}</span>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={columnClassName}>
                            {player.divisionCategoryName}
                        </div>
                        <div className={columnClassName}>
                            {player.medalTier && medalTiersList?.includes(player.medalTier) ? (
                                <>
                                    <Img
                                        className={styles.medalIcon}
                                        src={`/img/medals/${player.medalTier}.svg`}
                                    />
                                    <div className={styles.medalDescription}>
                                        {medalNames[player.medalTier]}
                                    </div>
                                </>
                            ) : '-'}
                        </div>
                        <div className={columnClassName}>
                            {isPickleballEvent ? (
                                <Rating
                                    utrType={utrTypeString}
                                    ratingType={'singles'}
                                    player={player}
                                    showDecimals={isCurrentMemberAdmin}
                                    hideUtrLabel={true}
                                    sportTypeId={sportTypeId}
                                    isPickleballRating
                                />
                            ) : (
                                <Rating
                                    utrType={utrTypeString}
                                    ratingType={'singles'}
                                    ratingStatus={player.ratingStatusSingles}
                                    player={player}
                                    showDecimals={isCurrentMemberAdmin}
                                    hideUtrLabel={true}
                                    sportTypeId={sportTypeId}
                                />
                            )}
                        </div>
                        <div className={columnClassName}>
                            {isPickleballEvent ? (
                                <Rating
                                    utrType={utrTypeString}
                                    ratingType={'doubles'}
                                    player={player}
                                    showDecimals={isCurrentMemberAdmin}
                                    hideUtrLabel={true}
                                    sportTypeId={sportTypeId}
                                    isPickleballRating
                                />
                            ) : (
                                <Rating
                                    utrType={utrTypeString}
                                    ratingType={'doubles'}
                                    ratingStatus={player.ratingStatusDoubles}
                                    player={player}
                                    showDecimals={isCurrentMemberAdmin}
                                    hideUtrLabel={true}
                                    sportTypeId={sportTypeId}
                                />
                            )}
                        </div>
                        <div className={columnClassName}>
                            {player.status}
                        </div>
                        <div className={`${columnClassName} flex-col ais`}>
                            <div className={styles.date}>
                                {player.displayDateSent}
                            </div>
                            <div className={styles.time}>
                                {player.displayTimeSent}
                            </div>
                        </div>
                        <div className={`${columnClassName} flex-col ais`}>
                            <div className={styles.date}>
                                {player.displayExpirationDate}
                            </div>
                            <div className={styles.time}>
                                {player.displayExpirationTime}
                            </div>
                        </div>
                        <div className={`${columnClassName} mr0`}>
                            <button
                                className={`btn btn-sm pl4 pr4 link clickable`}
                                type="button"
                                onClick={handleDeleteClick}
                            >
                                <Img
                                    src="/img/v4/icon-delete-blue.svg"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PreRegInvitedPlayer.propTypes = {
    player: PropTypes.objectOf(PropTypes.any).isRequired,
    gridLayout: PropTypes.arrayOf(PropTypes.string).isRequired,
    isPickleballEvent: PropTypes.bool,
    utrTypeId: PropTypes.number,
    sportTypeId: PropTypes.number,
    isCurrentMemberAdmin: PropTypes.bool,
    onDeleteInvite: PropTypes.func.isRequired,
};
PreRegInvitedPlayer.defaultProps = {
    isPickleballEvent: false,
    utrTypeId: 1,
    sportTypeId: 1,
    isCurrentMemberAdmin: false,
};

export default PreRegInvitedPlayer;
